import React from 'react'
import { registerRedirect } from '../../utils/router'
import { Button } from '../atoms/Button'
import CodeComponent from '../atoms/CodeComponent'

export const WelcomeSection = ({
    title1,
    title2,
    title3,
    subtitle1,
    subtitle2,
    buttonName,
    secondButtonName,
    onSecondButtonClick,
}: {
    title1: string
    title2: string
    title3: string
    subtitle1: string
    subtitle2: string
    buttonName: string
    secondButtonName?: string
    onSecondButtonClick?: () => void
}) => {
    return (
        <>
            <div className="snap-start pt-[50px] pb-0 gap-[24px] lg:py-[0px] px-[20px]  lg:px-[60px] w-full  items-center flex flex-col justify-center max-w-screen-xl mx-auto lg:justify-between lg:max-h-screen lg:min-h-screen">
                <div className="w-full lg:flex-row grid grid-cols-1 lg:grid-cols-2 place-content-center flex-grow gap-[24px] justify-center align-middle pt-[100px]">
                    <div className="flex flex-col gap-[16px]">
                        <div className="flex flex-col">
                            <div className="text-bold font-sansCondensed text-3xl lg:text-6xl font-black uppercase text-center lg:text-left">
                                {title1}
                            </div>
                            <div className="text-bold font-sansCondensed text-3xl lg:text-6xl font-black uppercase text-center lg:text-left">
                                {title2}
                            </div>
                            <div className="font-sansCondensed uppercase text-xl lg:text-4xl font-bold text-center lg:text-left">
                                {title3}
                            </div>
                        </div>
                        <div className="flex flex-col text-lg lg:text-2xl max-w-[500px] lg:placeholder:h-[100px] text-neutral-500 text-center lg:text-left">
                            <div>{subtitle1}</div>
                            <div>{subtitle2}</div>
                        </div>

                        <div className="w-full flex flex-wrap gap-4 mb-1">
                            {secondButtonName ? (
                                onSecondButtonClick ? (
                                    <Button
                                        color="green"
                                        name={secondButtonName}
                                        buttonClass="flex max-w-fit mx-auto lg:mx-0"
                                        onClick={onSecondButtonClick}
                                    />
                                ) : (
                                    <Button
                                        color="green"
                                        name={buttonName}
                                        buttonClass="flex max-w-fit mx-auto lg:mx-0"
                                        onClick={registerRedirect}
                                    />
                                )
                            ) : (
                                <></>
                            )}
                            <Button
                                color={secondButtonName ? 'black' : 'green'}
                                name={buttonName}
                                buttonClass="flex max-w-fit mx-auto lg:mx-0"
                                onClick={registerRedirect}
                            />
                        </div>
                    </div>
                    <div className="w-full">
                        <CodeComponent
                            choices={['INVITE.SH', 'EXAMPLE_PYTHON']}
                        />
                    </div>
                </div>
                <div className="bg-neutral-900 block text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl leading-tight sm:leading-none font-black font-sansCondensed uppercase text-outline w-screen overflow-hidden text-primary-700 outline-primary-500 text-center mt-auto pt-8 pb-0 px-2">
                    "It just works, reliably. Powering{' '}
                    <a
                        href="https://claap.io"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary-500 hover:text-primary-700 visited:text-primary-300 underline transition-colors duration-200"
                    >
                        Claap
                    </a>{' '}
                    meeting recording under the hood."
                    <br />
                    <span className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl font-normal block mt-2 mb-4">
                        - Robin Bonduelle, Claap CEO
                    </span>
                </div>
            </div>
        </>
    )
}
